import { ApiService } from "./api.service";

export const ResourceService = {
  getFile,
  fetchFolderList,
  fetchProduct
}

function getFile(nodeId){
  return ApiService.get(`/resource/file/${nodeId}`)
}

function fetchFolderList(search) {
  return ApiService.get(`/resource/folder/list?query=${search}`)
}

function fetchProduct(product_code) {
  return ApiService.get(`/resource/product/${product_code}`)
}


// WEBPACK FOOTER //
// ./src/services/resource.service.js